import { Flex, Skeleton } from 'antd';
import { FC } from 'react';

export const SkeletonWeapons: FC = () => {
  return (
    <>
      <Flex vertical gap={24}>
        <Skeleton.Button shape="square" block active className="weapon-registered__skeleton-filter" />
        <Skeleton.Button shape="square" block active className="weapon-registered__skeleton-filter" />
      </Flex>
      <Flex vertical gap={16}>
        {Array.from({ length: 4 }).map(() => (
          <Skeleton.Button
            shape="square"
            block
            active
            className="weapon-registered__skeleton-card"
            key={Math.random()}
          />
        ))}
      </Flex>
    </>
  );
};
